<!-- 上传课件 -->
<template>
  <div v-loading="loading" class="editHomework">
    <header class="header">
       <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="作业信息" name="1" v-if="activeName==1"></el-tab-pane>
        <el-tab-pane label="完成情况" name="2" v-if="activeName==2"></el-tab-pane>
      </el-tabs>
      <!-- <span>新建/编辑授课分组</span> -->
      <!-- <el-button @click="$router.go(-1)" class="back" size="mini" >返回</el-button> -->
      <el-button @click="onDetails(null)" class="back" size="mini"  v-if="!detailsType" >返回</el-button>
      <router-link :to="`/alliance/teacher/homework?schoolId=${$route.query.schoolId}&teacherId=${$route.query.teacherId}`">
        <el-button class="back" size="mini"  v-if="detailsType">返回</el-button>
      </router-link>
      <el-button type="primary" style="float: right;margin-right:10px;" size="mini" v-if="detailsType && activeName==2" @click="releases">发布成绩</el-button>
    </header>
    <!-- 作业信息 -->
    <div v-if="activeName==1">
      <el-form :model="announcement" ref="announcement" label-width="150px">
        <el-form-item label="作业标题" prop="name" :rules="[{ required: true, message: '作业标题不能为空'}]">
          <el-input
            type="name"
            v-model="announcement.name"
            :maxlength="50"
            placeholder="请输入课件名称"
            style="width:480px;"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="截止时间"
          prop="deadLine"
          :rules="[{ required: true, message: '截止时间不能为空'}]"
        >
          <el-date-picker
            v-model="announcement.deadLine"
            type="datetime"
            placeholder="选择截止时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          label="授课班级"
          prop="courseId"
          :rules="[{ required: true, message: '可见授课班级不能为空'}]"
        >
          <el-select v-model="announcement.courseId" placeholder="请选择" @change="changeCourse">
            <el-option v-for="item in cities" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span
            v-if="total"
            style="font-size: 16px;font-weight: 700;color: red;  padding-left: 20px;"
          >班级总人数：{{total}}</span>
        </el-form-item>
        <el-form-item
          label="应用软件"
          prop="softwareType"
        >
          <el-radio-group v-model="announcement.softwareType">
            <el-radio :label="1">AT</el-radio>
            <el-radio :label="2">AFM</el-radio>
            <el-radio :label="3">其它</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="作业附件"
          prop="attachmentTOS"
          :rules="[{ required: true, message: '选择文件不能为空'}]"
        >
          <UpFile
            @onSucceed="onFileUpLoad"
            :maxSize="100"
            v-if="announcement.attachmentTOS.length < 1"
          ></UpFile>
          <p v-for="(item,idx) in announcement.attachmentTOS" :key="idx" style="margin-top: 0px;">
            {{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.size}}kb
            <i
              class="el-icon-delete delete"
              @click="delFile(item,idx)"
            ></i>
          </p>
        </el-form-item>
        <el-form-item
          label="完成方式"
          prop="workType"
          :rules="[{ required: true, message: '完成方式不能为空'}]"
        >
          <el-radio-group v-model="announcement.workType">
            <el-radio :label="1">个人</el-radio>
            <el-radio :label="2">分组</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
        v-if="announcement.workType==2"
          label="分组方式"
          prop="workGroupId"
          :rules="[{ required: true, message: '分组方式不能为空'}]"
        >
          <el-select v-model="announcement.workGroupId" placeholder="请选择">
            <el-option
              v-for="item in workGroupAttr"
              :key="item.workGroupId"
              :label="item.workGroupName"
              :value="item.workGroupId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="作业描述"
          prop="introduce"
          :rules="[{ required: true, message: '作业描述不能为空'}]"
        >
          <rich-editor :value="announcement.introduce" ref="answer"></rich-editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('announcement')">提交</el-button>
          <el-button @click="$router.go(-1)">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 完成情况 -->
    <div v-if="activeName==2">
      <complete @onDetails="onDetails" v-if="detailsType"></complete>
      <detailsInfo v-if="!detailsType" :detailsData='detailsData' @onSave='onSave'></detailsInfo>
    </div>
  </div>
</template>

<script>
import UpFile from "../common/uploadFile";
import richEditor from "@/components/common/RichEditor.vue";
import complete from "./complete"
import detailsInfo from "./detailsInfo"
export default {
  components: {
    richEditor,
    UpFile,complete,detailsInfo
  },
  data() {
    return {
      detailsType:true,
      total: null,
      activeName:this.$route.query.type,
      loading: false,
      checkAll: false,
      cities: [], // 总数据
      isIndeterminate: false,
      workGroupAttr: [], // 分组下拉框数据
      detailsData:{},
      param: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId
      }, // 可见授课班级
      announcement: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
        name: "", // 标题
        attachmentTOS: [], // 作业附件列表
        courseId: null, // 发布授课班级
        deadLine: "", // 截止时间
        id: 0,
        introduce: "", // 作业描述 富文本
        softwareType: 3, // 应用软件 1：at 2：afm
        workGroupId: null, // 分组id
        workType: null // 完成方式 1：个人 2：分组
      }
    };
  },
  created() {
    this.getCourseSummaryList();
  },
  methods: {
    // 发布成绩
    releases(){
    this.$confirm("是否发布该成绩？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          const param ={
              schoolId:this.$route.query.schoolId,
              workId:this.$route.query.courseWorkId,
          }
        this.$api.allianceSchool.publishWorkScore(param).then(res => {
            if (res.errCode == 0) {
              this.$message.success('发布成功！');
            } else {
              this.$message.error(res.errMsg);
            }
        })
      });
    },
    // 作业列表详情保存
    onSave(item){
      if(item.type=='save'){
        this.$api.allianceSchool.correctStudentWork(item.child).then(res => {
            if (res.errCode == 0) {
               this.detailsData = {};
              this.detailsType = true;
            } else {
              this.$message.error(res.errMsg);
            }
        })
      }else{
        this.detailsData = {};
        this.detailsType = true;
      }
      
    },
    // 完成情况详情
    onDetails(item){
      if(item){
        const param = {
          schoolId:this.$route.query.schoolId,
          studentWorkId:item.studentWorkId,
        }
      this.$api.allianceSchool.getWorkFinishInfo(param).then(res => {
        this.detailsData = res.data;
        this.detailsType = false;
      })
      }else{
        // 返回
        this.detailsType = true;
      }
    },
    handleClick(item){
        console.log(this.handleClick)
    },
    // 授课班级》获取分组下拉
    changeCourse() {
      const param = {
        courseId: this.announcement.courseId,
        schoolId: this.$route.query.schoolId
      };
      this.loading = true;
      this.$api.allianceSchool.getCourseGroup(param).then(res => {
        this.loading = false;
        if (res.errCode == 0) {
          this.workGroupAttr = res.data.groupSettings;
        } else {
          this.$message.error(res.errMsg);
        }
      }).catch(res=>{
        this.loading = false;
      });
    },
    // 保存
    submitForm(formName) {
      this.announcement.introduce = this.$refs.answer.getContent(); // 拿到富文本的内容
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.$api.allianceSchool
            .updateCourseWork(this.announcement)
            .then(res => {
              this.loading = false;
              if (res.errCode == 0) {
                 this.$message.success("提交成功!");
                this.$router.go(-1);
              } else {
                this.$message.error(res.errMsg);
              }
            }).catch(res=>{
        this.loading = false;
      });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除文件
    delFile(item, idx) {
      const than = this;
        this.$confirm("您确认删除？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          than.announcement.attachmentTOS.splice(idx, 1);
      });
    },
    // 上传
    onFileUpLoad(res) {
      const param = {
        name: res.file.name,
        size: (res.file.size / 1024).toFixed(2),
        url: res.item.url
      };
      this.announcement.attachmentTOS.push(param);
    },
    // 获取可见授课班级
    getCourseSummaryList() {
      this.loading = true;
      this.$api.allianceSchool.getCourseSummaryList(this.param).then(res => {
        this.loading = false;
        if (res.errCode == 0) {
          this.cities = res.data;
        } else {
          this.$message.error(res.errMsg);
        }
      }).catch(res=>{
        this.loading = false;
      });
      if(this.$route.query.courseWorkId){
         const workparam = {
        schoolId: this.$route.query.schoolId,
        workId: this.$route.query.courseWorkId
      };
      this.loading = true;
      this.$api.allianceSchool.getCourseWorkInfo(workparam).then(res => {
        this.loading = false;
        if (res.errCode == 0) {
          this.announcement = {
                schoolId: this.$route.query.schoolId,
                teacherId: this.$route.query.teacherId,
                name: res.data.workName, // 标题
                attachmentTOS: res.data.attachments, // 作业附件列表
                courseId: res.data.courseId, // 发布授课班级
                deadLine: res.data.deadLine, // 截止时间
                id: this.$route.query.courseWorkId,
                introduce: res.data.introduce, // 作业描述 富文本
                softwareType: res.data.softwareType, // 应用软件 1：at 2：afm
                workGroupId: res.data.workGroupId, // 分组id
                workType: res.data.workType // 完成方式 1：个人 2：分组
            };
            this.changeCourse();    // 获取分组下拉框
        } else {
          this.$message.error(res.errMsg);
        }
        }).catch(res=>{
        this.loading = false;
      });
      }
    }
  }
};
</script>
<style lang='less' scoped>
.editHomework{
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
}
.delete {
  font-size: 20px;
  color: red;
  cursor: pointer;
  padding-left: 10px;
}
.header{
position: relative;
.back{
    position: absolute;
    right: 0;
    top: 20px;
}
}
</style>